module.exports = __webpack_public_path__ + "img/networking-icon.160177ca.png";